export default "__VITE_ASSET__a94572fb__"